/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DevicePlatform;
(function (DevicePlatform) {
    DevicePlatform["Mpns"] = "Mpns";
    DevicePlatform["Wns"] = "Wns";
    DevicePlatform["Apns"] = "Apns";
    DevicePlatform["Fcm"] = "Fcm";
})(DevicePlatform || (DevicePlatform = {}));
export function DevicePlatformFromJSON(json) {
    return DevicePlatformFromJSONTyped(json, false);
}
export function DevicePlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DevicePlatformToJSON(value) {
    return value;
}
